import React from 'react';
import axios from 'axios';
import { Redirect } from 'react-router';
import {
    Button,
    Divider,
    Form,
    Grid,
    Header,
    Icon,
    Input,
    Popup,
    Responsive,
    Segment, SegmentGroup,
    Select,
    Tab
} from 'semantic-ui-react';
import request from '../../util/request';
import {toast, ToastContainer} from 'react-toastify';
import { DateTimePicker } from 'react-widgets';
import PreviousEducations from '../../StudentService/StudentCreateAndEdit/PreviousEducations';
import PlaceForm from '../../util/PlaceForm';


axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;


class AddNewPerson extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            success: false,
            activeIndex: 0,

            jmbg: this.props.location.state.jmbg,
            firstName: null,
            lastName: null,
            maidenName: null,
            dateOfBirth: null,
            genders: [],
            gender: null,
            nationalities: [],
            selectedCitizenships: [],
            citizenships: [],
            nationality: null,

            motherFirstName: null,
            motherLastName: null,
            fatherFirstName: null,
            fatherLastName: null,

            bihId: null,
            fbihId: null,

            personId: null,

            jmbgErr: false,
            firstNameErr: false,
            lastNameErr: false,
            dateOfBirthErr: false,
            genderErr: false,
            placeOfBirthErr: false,
            placeOfResidenceErr: false,
            placeOfCurrentResidenceErr: false,
            selectedCitizenshipsErr: false,

            institutionTypes: [],
            institutionType: null,
            educationLevels: [],
            educationLevel: null,
            previousEducations: [],

            placeOfBirth: {
                country: null,
                entity: null,
                canton: null,
                municipality: null,
                place: null,
            },

            placeOfResidence: {
                country: null,
                entity: null,
                canton: null,
                municipality: null,
                place: null,
                address: null
            },

            placeOfCurrentResidence: {
                country: null,
                entity: null,
                canton: null,
                municipality: null,
                place: null,
                address: null
            },

            allPreviousEducations: []
        };

        this.handleInputChange = this.handleInputChange.bind(this);
        this.handleDateChange = this.handleDateChange.bind(this);
        this.onAddNewPreviousEducation = this.onAddNewPreviousEducation.bind(this);
        this.onDeletePreviousEducation = this.onDeletePreviousEducation.bind(this);
        this.onPlaceChange = this.onPlaceChange.bind(this);
        this.createPerson = this.createPerson.bind(this);
        this.chechInputFields = this.chechInputFields.bind(this);
    }

    componentDidMount() {
        request.fetchNationalitiesWithDefaultKey()
            .then(({ nationalities, defaultUnknownNationalityId }) => {
                this.setState({ nationalities, nationality: defaultUnknownNationalityId });
            }).catch(err => console.log(err));
        request.fetchCountriesWithDefaultKey()
            .then(({ bihId }) => this.setState({ bihId }));
        request.fetchEntitiesWithDefaultKey()
            .then(({ fbihId }) => this.setState({ fbihId }));

        request.fetchInstitutionTypes()
            .then(institutionTypes => this.setState({ institutionTypes }));

        request.fetchEducationLevels()
            .then(educationLevels => this.setState({ educationLevels }));

        axios.get('/countries')
            .then(res => {
                const citizenships = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ citizenships });
            })
            .catch(err => {
                console.log('Failed to fetch citizenships');
            });

        axios.get('/entities')
            .then(res => {
                this.setState({ bdId: res.data.find(el => el._key === 'bd').id });
            });

        axios.get('/genders')
            .then(res => {
                const genders = res.data.map(el => ({
                    value: el.id,
                    key: el.id,
                    text: el.name
                }));
                this.setState({ genders });
            })
            .catch(err => {
                console.log('Failed to fetch genders');
            });
    }


    handleDateChange(date) {
        this.setState({ dateOfBirth: date });
    }
    handleInputChange(e, { name, value }) {
        if (name === 'gender') { this.setState({ maidenName: '' }); }
        this.setState({ [name]: value });
    }
    showNationality() {
        return !!this.state.selectedCitizenships.find(el => this.state.bihId === el);
    }

    onAddNewPreviousEducation(prevEducation) {
        const { allPreviousEducations } = this.state;
        this.setState({ allPreviousEducations: [...allPreviousEducations, prevEducation] });
    }

    onDeletePreviousEducation(index) {
        const filtered = this.state.allPreviousEducations.filter((el, i) => i !== index);
        this.setState({ allPreviousEducations: filtered });
    }

    onPlaceChange(values, formName) {
        this.setState({ [formName]: values });
    }

    handleTabChange = (e, { activeIndex }) => this.setState({ activeIndex })


    chechInputFields() {
        if (!this.state.firstName || !this.state.lastName || !this.state.dateOfBirth || !this.state.gender || (this.state.selectedCitizenships.length === 0)
            || (localStorage.getItem('associate') === 'true' && !this.state.placeOfBirth.country)
            || !this.state.placeOfResidence.country || !this.state.placeOfBirth.country
            || (this.state.placeOfCurrentResidence.country && (!this.state.placeOfCurrentResidence.place || !this.state.placeOfCurrentResidence.address))
            || (this.state.allPreviousEducations.length === 0 && localStorage.getItem('academicStaff') === 'false')
        ) {
            toast('Niste unijeli sva obavezna polja!');
            if (!this.state.firstName) {
                this.setState({firstNameErr: true});
            } else {
                this.setState({firstNameErr: false});
            }
            if (!this.state.lastName) {
                this.setState({lastNameErr: true});
            } else {
                this.setState({lastNameErr: false});
            }
            if (!this.state.dateOfBirth) {
                this.setState({dateOfBirthErr: true});
            } else {
                this.setState({dateOfBirthErr: false});
            }
            if (!this.state.gender) {
                this.setState({genderErr: true});
            } else {
                this.setState({genderErr: false});
            }
            if (this.state.selectedCitizenships.length === 0) {
                this.setState({selectedCitizenshipsErr: true});
            } else {
                this.setState({selectedCitizenshipsErr: false});
            }

            if (localStorage.getItem('associate') === 'true' && !this.state.placeOfBirth.country) {
                    this.setState({placeOfBirthErr: true});
                } else {
                    this.setState({placeOfBirthErr: false});
                }

            if (!this.state.placeOfBirth.country) {
                this.setState({placeOfBirthErr: true});
            } else {
                this.setState({placeOfBirthErr: false});
            }
            if (!this.state.placeOfResidence.country) {
                this.setState({placeOfResidenceErr: true});
            } else {
                this.setState({placeOfResidenceErr: false});
            }
        } else {
            this.createPerson();
        }
    }

    createPerson() {
        const {
            jmbg,
            firstName,
            lastName,
            maidenName,
            dateOfBirth,
            gender,
            selectedCitizenships,
            nationality,
            placeOfBirth,
            placeOfResidence,
            placeOfCurrentResidence,
            motherFirstName,
            motherLastName,
            fatherFirstName,
            fatherLastName,
            fbihId,
            bdId,
            allPreviousEducations

        } = this.state;

        let obj = {
            jmbg,
            firstName,
            lastName,
            maidenName: maidenName || null,
            dateOfBirth,
            gender: { id: gender },
            citizenships: selectedCitizenships.map((el, index) =>
                ({
                    country: { id: el },
                    priority: index + 1
                })),
            nationality: nationality ? { id: nationality } : null,
            placeOfBirth: {
                name: placeOfBirth.place,
                country: { id: placeOfBirth.country },
                entity: placeOfBirth.entity ? { id: placeOfBirth.entity } : null,
                canton: fbihId !== placeOfBirth.entity ? null : placeOfBirth.canton ? { id: placeOfBirth.canton } : null,
                municipality: placeOfBirth.entity ? placeOfBirth.municipality ? { id: placeOfBirth.municipality } : null : null
            },

        };

        if (placeOfResidence) {
            obj = {
                ...obj,
                residence: (placeOfResidence.country === '' || !placeOfResidence.country) ? null
                    : {
                        street: placeOfResidence.address,
                        place: {
                            name: placeOfResidence.place,
                            country: { id: placeOfResidence.country },
                            entity: placeOfResidence.entity ? { id: placeOfResidence.entity } : null,
                            canton: fbihId !== placeOfResidence.entity ? null : placeOfResidence.canton ? { id: placeOfResidence.canton } : null,
                            municipality: placeOfResidence.entity ? placeOfResidence.municipality ? { id: placeOfResidence.municipality } : null : null
                        }
                    }
            };
        }

        if (placeOfCurrentResidence) {
            obj = {
                ...obj,
                currentResidence: (placeOfCurrentResidence.country === '' || !placeOfCurrentResidence.country) ? null
                    : {
                        street: placeOfCurrentResidence.address,
                        place: {
                            name: placeOfCurrentResidence.place,
                            country: { id: placeOfCurrentResidence.country },
                            entity: placeOfCurrentResidence.entity ? { id: placeOfCurrentResidence.entity } : null,
                            canton: fbihId !== placeOfCurrentResidence.entity ? null : placeOfCurrentResidence.canton ? { id: placeOfCurrentResidence.canton } : null,
                            municipality: placeOfCurrentResidence.entity ? placeOfCurrentResidence.municipality ? { id: placeOfCurrentResidence.municipality } : null : null
                        }
                    }
            };
        }

        let previousEducations = allPreviousEducations.map(el => ({
            comment: el.comment,
            averageGrade: el.averageGrade,
            licenceNumber: el.licenceNumber,
            educationLevel: { id: el.educationLevel ? el.educationLevel : null },
            institution: { id: el.institution.id },
            id: el.id ? el.id : null,
            // optLock: el.optLock ? el.optLock : null
        }));

        if (previousEducations.length) obj = { ...obj, previousEducations };

        let mother = {
            gender: { id: 2 },
            firstName: motherFirstName,
            lastName: motherLastName
        };

        let father = {
            gender: { id: 1 },
            firstName: fatherFirstName,
            lastName: fatherLastName
        };

        if (motherLastName || motherFirstName) obj = { ...obj, mother };
        if (fatherLastName || fatherFirstName) obj = { ...obj, father };

        let academicStaff = null;
        let associate = false;
        if (localStorage.getItem('academicStaff') === 'true') academicStaff = true;
        if (localStorage.getItem('academicStaff') === 'false') academicStaff = false;
        if (localStorage.getItem('associate') === 'true') associate = true;

        axios.post(`hr/person/add/${academicStaff}/${associate}`, { ...obj })
            .then(res => {
                localStorage.setItem('person', JSON.stringify(res.data));
                localStorage.setItem('main', 'true');
                this.setState({ create: true, success: true });
                toast('Dodavanje osobe je uspješno završeno.')
            })
            .catch(err => {
                if (err.response.data === 'Person with this JMBG already exists!') {
                    toast('Osoba sa ovim JMBG-om već postoji!');
                } else {
                    toast('Došlo je do greške! Dodavanje osobe nije uspjelo.');
                }
                this.setState({ create: true, success: false});
            });
    }


    render() {
        const panes = [
            {
                menuItem: 'Lični podaci',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>
                        <Form>
                            <Form.Field
                                disabled
                                required
                                type="number"
                                control={Input}
                                label="JMBG"
                                placeholder="JMBG"
                                value={this.state.jmbg}
                                name="jmbg"
                                onChange={this.handleInputChange}
                                error={this.state.jmbgErr}
                            />

                            <Form.Field
                                required
                                control={Input}
                                label="Ime"
                                placeholder="Ime"
                                value={this.state.firstName}
                                name="firstName"
                                onChange={this.handleInputChange}
                                error={this.state.firstNameErr}
                            />
                            <Form.Field
                                required
                                control={Input}
                                label="Prezime"
                                placeholder="Prezime"
                                value={this.state.lastName}
                                name="lastName"
                                onChange={this.handleInputChange}
                                error={this.state.lastNameErr}
                            />

                            <Form.Field
                                required
                                control={DateTimePicker}
                                label="Datum rođenja"
                                format="D. M. YYYY."
                                time={false}
                                onChange={this.handleDateChange}
                                value={this.state.dateOfBirth}
                                style={{ borderWidth: '0px' }}
                                error={this.state.dateOfBirthErr}
                            />
                            <Form.Field
                                required
                                control={Select}
                                label="Spol"
                                options={this.state.genders}
                                placeholder="Spol"
                                onChange={this.handleInputChange}
                                name="gender"
                                value={this.state.gender}
                                error={this.state.genderErr}
                            />

                            <Form.Field
                                control={Input}
                                label="Djevojačko prezime"
                                placeholder="Djevojačko prezime"
                                value={this.state.maidenName}
                                name="maidenName"
                                onChange={this.handleInputChange}
                                disabled={this.state.gender === null || this.state.gender === 1}
                                // error={this.state.lastNameErr}
                            />

                            <Form.Field required error={this.state.selectedCitizenshipsErr}>
                                <label>Državljanstvo</label>
                                <Form.Dropdown
                                    selection
                                    required
                                    options={this.state.citizenships}
                                    onChange={this.handleInputChange}
                                    value={this.state.selectedCitizenships}
                                    name="selectedCitizenships"
                                    placeholder="Državljanstvo"
                                    search
                                    multiple
                                    fluid
                                />
                            </Form.Field>
                            <Form.Field
                                required
                                control={Select}
                                label="Nacionalnost"
                                options={this.state.nationalities}
                                value={this.state.nationality}
                                onChange={this.handleInputChange}
                                name="nationality"
                                search
                                disabled={!this.state.selectedCitizenships.length || !this.state.selectedCitizenships.find(el => el === this.state.bihId)}
                            />
                        </Form>
                    </div></Tab.Pane>)
            },
            {
                menuItem: 'Mjesto rođenja',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>
                        <PlaceForm
                            values={this.state.placeOfBirth}
                            formName="placeOfBirth"
                            onPlaceChange={this.onPlaceChange}
                            fieldErr={this.state.placeOfBirthErr}
                            //bdId={this.props.bdId}
                            noAdress
                        />

                    </div></Tab.Pane>)
            },
            {
                menuItem: 'Podaci o roditeljima',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>
                        <Form>
                            <Form.Field
                                disabled={localStorage.getItem('associate') === 'true'}
                                control={Input}
                                label="Ime oca"
                                placeholder="Ime oca"
                                value={this.state.fatherFirstName}
                                name="fatherFirstName"
                                onChange={this.handleInputChange}
                            />
                            <Form.Field
                                disabled={localStorage.getItem('associate') === 'true'}
                                control={Input}
                                label="Prezime oca"
                                placeholder="Prezime oca"
                                value={this.state.fatherLastName}
                                name="fatherLastName"
                                onChange={this.handleInputChange}
                            />
                            <br />
                            <br />
                            <br />
                            <br />
                            <Form.Field
                                disabled={localStorage.getItem('associate') === 'true'}
                                control={Input}
                                label="Ime majke"
                                placeholder="Ime majke"
                                value={this.state.motherFirstName}
                                name="motherFirstName"
                                onChange={this.handleInputChange}
                            />
                            <Form.Field
                                disabled={localStorage.getItem('associate') === 'true'}
                                control={Input}
                                label="Prezime majke"
                                placeholder="Prezime majke"
                                value={this.state.motherLastName}
                                name="motherLastName"
                                onChange={this.handleInputChange}
                            />
                        </Form>
                    </div></Tab.Pane>)
            },
            localStorage.getItem('academicStaff') === 'false'  && {
                menuItem: 'Prethodno obrazovanje',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>
                        <PreviousEducations
                            noSegment
                            institutionTypes={this.state.institutionTypes}
                            educationLevels={this.state.educationLevels}
                            institutions={this.state.institutions}
                            onAddNewPreviousEducation={this.onAddNewPreviousEducation}
                            previousEducations={this.state.allPreviousEducations}
                            onDeletePreviousEducation={this.onDeletePreviousEducation}
                            disabled={localStorage.getItem('academicStaff') === 'true' ? true : localStorage.getItem('academicStaff') === 'false' ? false : null}
                        />
                    </div></Tab.Pane>)
            },
            {
                menuItem: 'Prebivalište i boravište',
                render: () => (<Tab.Pane attached={false} as={Responsive}>
                    <div>
                        <Grid columns="equal" centered className="stackable" disabled={localStorage.getItem('associate') === 'true'}>
                            <Grid.Row streched>
                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header as="h4">Prebivalište</Header>
                                    </Divider>
                                    <PlaceForm
                                        values={this.state.placeOfResidence}
                                        formName="placeOfResidence"
                                        onPlaceChange={this.onPlaceChange}
                                        fieldErr={this.state.placeOfResidenceErr}
                                        //bdId={this.props.bdId}
                                    /></Grid.Column>
                                <Grid.Column>
                                    <Divider horizontal>
                                        <Header disabled={localStorage.getItem('associate') === 'true'} as="h4">Boravište</Header>
                                    </Divider>
                                    <PlaceForm
                                        values={this.state.placeOfCurrentResidence}
                                        formName="placeOfCurrentResidence"
                                        onPlaceChange={this.onPlaceChange}
                                        fieldErr={this.state.placeOfCurrentResidenceErr}
                                        //bdId={this.props.bdId}
                                        currentResidence
                                    /></Grid.Column>
                            </Grid.Row></Grid>
                    </div></Tab.Pane>)
            }
        ];

   if (this.state.success) {
            return <Redirect push to={{ pathname: '/pretraga-i-unos-osobe/dodavanje-zaposlenika' }} />;
        }

        return (
            <div>
                <Header as="h1"> Dodavanje osobe
                </Header>
                <SegmentGroup raised>
                    <Segment>
                        <Header as="h3">
                            Dodavanje osobe
                        </Header>
                    </Segment>
                    <Segment>
                        <Tab
                            menu={{
                                secondary: true, pointing: true, color: 'blue', vertical: true, fluid: true, attached: true, tabular: true
                            }}
                            grid={{ paneWidth: 13, tabWidth: 3 }}
                            panes={panes}
                            onTabChange={this.handleTabChange}
                            activeIndex={this.state.activeIndex}
                        />

                        <Segment vertical clearing />
                        <Segment vertical clearing>
                            {this.state.activeIndex > 3 ?
                                <Button primary onClick={this.chechInputFields} floated="right">Dodaj osobu</Button> : ''}
                            {this.state.activeIndex < 4 ? <Button
                                content="Nastavi"
                                icon="right arrow"
                                basic
                                color="blue"
                                labelPosition="right"
                                onClick={() => this.setState({ activeIndex: this.state.activeIndex + 1 })}
                                floated="right"
                            /> : ''}
                            {this.state.activeIndex > 0 ?
                                <Button
                                    content="Nazad"
                                    icon="left arrow"
                                    basic
                                    color="blue"
                                    labelPosition="left"
                                    onClick={() => this.setState({ activeIndex: this.state.activeIndex - 1 })}
                                    floated="left"
                                /> : ''}

                        </Segment>
                    </Segment>
                </SegmentGroup>

                <ToastContainer hideProgressBar />
            </div>
        );
    }
}

export default AddNewPerson;



// WEBPACK FOOTER //
// ./src/views/HR/add/AddNewPerson.js